module.exports = __webpack_public_path__ + "img/webcontact.75d36949.webp";